import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import Select from "../../../common/Select";
import { OilRequestOilType } from "../../../utils/config";
import { oilMarkingOptions, oilPurposeOptions } from "../helpers";

export type Oil = {
  oilCode: string;
  amount: string;
  // hasBioAdditive?: boolean;
  // hvo?: string;
  marking?: string;
  purpose?: string;
};

type Props = {
  title: string;
  oil: Oil;
  isMobile: boolean;
  onChange: (oil: Oil) => void;
  error?: Partial<Record<keyof Oil, string>>;
};

const OilForm: React.FC<Props> = ({
  oil,
  title,
  error,
  isMobile,
  onChange,
}): React.ReactElement => {
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onChange({ ...oil, [name]: value });
  };

  const handleSelectChange = (
    o: { value: any } | null,
    m: { name?: string },
  ) => {
    const { value } = o || {};
    const { name } = m;
    onChange({ ...oil, [name]: value });
  };

  return (
    <>
      {!isMobile ? (
        <tr>
          <td>{title}</td>
          <td>
            <InputGroup>
              <Form.Control
                style={{ fontSize: "14px" }}
                type="number"
                onChange={handleTextChange}
                name="amount"
                isInvalid={!!error?.amount}
                value={oil.amount}
              />
              <InputGroup.Text>Liitrit</InputGroup.Text>
              <Form.Control.Feedback type="invalid">
                {error?.amount}
              </Form.Control.Feedback>
            </InputGroup>
          </td>
          <td>
            {[
              String(OilRequestOilType.DieselSpecial),
              String(OilRequestOilType.Diesel),
            ].includes(oil.oilCode) && (
              <Form.Group>
                <Select
                  isClearable
                  onChange={handleSelectChange}
                  name="marking"
                  placeholder=""
                  options={oilMarkingOptions}
                  isInvalid={!!error?.marking}
                  fontSize="14px"
                  value={oilMarkingOptions.filter(
                    (o) => o.value === oil.marking,
                  )}
                />
                <Form.Control.Feedback type="invalid">
                  {error?.marking}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </td>
          <td>
            {[String(OilRequestOilType.DieselSpecial)].includes(
              oil.oilCode,
            ) && (
              <Form.Group>
                <Select
                  isClearable
                  onChange={handleSelectChange}
                  name="purpose"
                  placeholder=""
                  options={oilPurposeOptions}
                  isInvalid={!!error?.purpose}
                  fontSize="14px"
                  value={oilPurposeOptions.filter(
                    (o) => o.value === oil.purpose,
                  )}
                />
                <Form.Control.Feedback type="invalid">
                  {error?.purpose}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </td>
        </tr>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="is-mobile__title">{title}</div>
          <div>
            <div className="is-mobile__input_label">Sisesta kogus</div>
            <InputGroup>
              <Form.Control
                style={{ fontSize: "14px" }}
                type="number"
                onChange={handleTextChange}
                name="amount"
                isInvalid={!!error?.amount}
                value={oil.amount}
              />
              <InputGroup.Text>Liitrit</InputGroup.Text>
              <Form.Control.Feedback type="invalid">
                {error?.amount}
              </Form.Control.Feedback>
            </InputGroup>
          </div>

          {[
            String(OilRequestOilType.DieselSpecial),
            String(OilRequestOilType.Diesel),
          ].includes(oil.oilCode) && (
            <div style={{ marginTop: "17px" }}>
              <div className="is-mobile__input_label">Märgistus</div>
              <Form.Group>
                <Select
                  isClearable
                  onChange={handleSelectChange}
                  name="marking"
                  placeholder=""
                  options={oilMarkingOptions}
                  isInvalid={!!error?.marking}
                  fontSize="14px"
                  value={oilMarkingOptions.filter(
                    (o) => o.value === oil.marking,
                  )}
                />
                <Form.Control.Feedback type="invalid">
                  {error?.marking}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          )}
          {[String(OilRequestOilType.DieselSpecial)].includes(oil.oilCode) && (
            <div style={{ marginTop: "17px" }}>
              <div className="is-mobile__input_label">Otstarve</div>
              <Form.Group>
                <Select
                  isClearable
                  onChange={handleSelectChange}
                  name="purpose"
                  placeholder=""
                  options={oilPurposeOptions}
                  isInvalid={!!error?.purpose}
                  fontSize="14px"
                  value={oilPurposeOptions.filter(
                    (o) => o.value === oil.purpose,
                  )}
                />
                <Form.Control.Feedback type="invalid">
                  {error?.purpose}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default OilForm;
